import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import SellVats from '../../features/accountings/SellVats';
import SellVatsDetails from '../../features/accountings/SellVatsDetails';
import PurchaseVats from '../../features/accountings/PurchaseVats';
import PurchaseVatsDetails from '../../features/accountings/PurchaseVatsDetails';
import SellAccountingGroups from '../../features/accountings/SellAccountingGroups';
import PurchaseAccountingGroups from '../../features/accountings/PurchaseAccountingGroups';
import SellAccountingGroupDetailsView from '../../features/accountings/SellAccountingGroupDetailsView';
import PurchaseAccountingGroupDetailsView from '../../features/accountings/PurchaseAccountingGroupDetailsView';
import NotFound from '../../common/components/router/NotFound';
import WintimeTransfer from '../../features/accountings/WintimeTransfer';
import SalesStatis from '../../features/statistics/SalesStatistics';
import SellStats from '../../features/accountings/SellStats';
import PreSellStats from '../../features/accountings/PreSellStats';
import TravelAgencyReport from '../../features/statistics/TravelAgencyReport';
import InterHomeReport from '../../features/statistics/InterHomeReport';
import SettlementReport from '../../features/statistics/SettlementReport';
import OwnerReport from '../../features/statistics/OwnerReport';
import AgentReport from '../../features/statistics/AgentReport';
import Dac7Reports from '../../features/dac7/Dac7Reports';
import Invoices from '../../features/invoicing/Invoices';

const AccountingAppRoutes = () => (
  <Routes>
    <Route
      path="/sellvats"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <SellVats />
        </PrivateRoute>
      }
    />
    <Route
      path="/sellvats/details/:sellVatsId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.FinancialRead, PERMISSIONS.FinancialModify]}
        >
          <SellVatsDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/purchasevats"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <PurchaseVats />
        </PrivateRoute>
      }
    />
    <Route
      path="/purchasevats/details/:purchaseVatsId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.FinancialRead, PERMISSIONS.FinancialModify]}
        >
          <PurchaseVatsDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/sellaccountinggroups"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <SellAccountingGroups />
        </PrivateRoute>
      }
    />
    <Route
      path="/purchaseaccountinggroups"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <PurchaseAccountingGroups />
        </PrivateRoute>
      }
    />
    <Route
      path="/generateandsendaccountingdata"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <WintimeTransfer />
        </PrivateRoute>
      }
    />
    <Route
      path="/sellstats"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <SellStats />
        </PrivateRoute>
      }
    />
    <Route
      path="/presellstats"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <PreSellStats />
        </PrivateRoute>
      }
    />
    <Route
      path="/sellaccountinggroups/:accountingGroupId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.FinancialRead, PERMISSIONS.FinancialModify]}
        >
          <SellAccountingGroupDetailsView />
        </PrivateRoute>
      }
    />
    <Route
      path="/purchaseaccountinggroups/:accountingGroupId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.FinancialRead, PERMISSIONS.FinancialModify]}
        >
          <PurchaseAccountingGroupDetailsView />
        </PrivateRoute>
      }
    />
    <Route
      path="/salesstatistics"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <SalesStatis />
        </PrivateRoute>
      }
    />
    <Route
      path="/travelagencyreport"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <TravelAgencyReport />
        </PrivateRoute>
      }
    />
    <Route
      path="/interhomereport"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialRead]}>
          <InterHomeReport />
        </PrivateRoute>
      }
    />
    <Route
      path="/agentreport"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <AgentReport />
        </PrivateRoute>
      }
    />
    <Route
      path="/settlementreport"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <SettlementReport />
        </PrivateRoute>
      }
    />
    <Route
      path="/ownerreport"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <OwnerReport />
        </PrivateRoute>
      }
    />
    <Route
      path="/dac7reports"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialModify]}>
          <Dac7Reports />
        </PrivateRoute>
      }
    />
    <Route
      path="/invoices"
      element={
        <PrivateRoute permissions={[PERMISSIONS.FinancialModify]}>
          <Invoices />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AccountingAppRoutes;
